// StartTime holds the `startTime` embed arg (seconds into a recording, e.g. from a
// boxcast.tv `?t=` link) until the broadcast it was meant for loads.
//
// The time is measured from the start of the recording as it plays now. If the
// recording is later trimmed, the link keeps pointing at the same position on the
// trimmed timeline, not at the same moment of content.
//
// It is handed out at most once. Picking another broadcast from the playlist, coming
// back to this one, or the live-to-recorded DVR transition all start playback as usual.
export default class StartTime {
  constructor(startTime, selectedBroadcastId) {
    var seconds = parseFloat(startTime);
    this._seconds = isFinite(seconds) && seconds > 0 ? seconds : null;
    this._selectedBroadcastId = selectedBroadcastId ? String(selectedBroadcastId) : null;
  }

  // returns the time to seek to when loading the given broadcast, or null. a live
  // broadcast or a highlight uses up the start time without seeking, since a recording
  // offset doesn't mean anything on their timelines.
  take(broadcast, { isLive, isHighlight }) {
    if (this._seconds === null || !broadcast) {
      return null;
    }
    if (this._selectedBroadcastId && String(broadcast.id) !== this._selectedBroadcastId) {
      return null;
    }
    var seconds = this._seconds;
    this._seconds = null;
    return isLive || isHighlight ? null : seconds;
  }
}
